import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { requestPasswordReset } from '../lib/auth';
import { PASSWORD_RESET_SCOPES, parsePasswordResetScope } from '../lib/passwordReset';
import { theme } from '../lib/theme';

export default function ForgotPassword() {
  const [searchParams] = useSearchParams();
  const scope = parsePasswordResetScope(searchParams.get('scope'));
  const meta = PASSWORD_RESET_SCOPES[scope];

  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const { error: err } = await requestPasswordReset(email, scope);
      if (err) {
        setError(err.message || 'Could not send reset email.');
        return;
      }
      setSent(true);
    } finally {
      setBusy(false);
    }
  }

  const shell = {
    minHeight: '100vh',
    background: scope === 'marketplace' ? theme.bg : '#0f1419',
    color: scope === 'marketplace' ? theme.text : '#e8eaed',
    fontFamily: scope === 'marketplace' ? theme.font : "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  };

  const accent = scope === 'marketplace' ? theme.accent : '#0d7377';
  const muted = scope === 'marketplace' ? theme.muted : '#9aa0a6';

  if (sent) {
    return (
      <div style={shell}>
        <div style={{ width: '100%', maxWidth: 420 }}>
          <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 12 }}>Check your email</h1>
          <p style={{ color: muted, fontSize: 15, lineHeight: 1.5 }}>
            If an account exists for <strong style={{ color: 'inherit' }}>{email.trim()}</strong>, we sent a
            link to reset your password. Open the link on this device, then choose a new password.
          </p>
          <p style={{ color: muted, fontSize: 14, marginTop: 16 }}>
            Did not receive it? Check spam, or confirm the email matches your {meta.label} account.
          </p>
          <p style={{ marginTop: 28 }}>
            <Link to={meta.loginPath} style={{ color: accent, fontWeight: 600, textDecoration: 'none' }}>
              ← Back to sign in
            </Link>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={shell}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>Reset password</h1>
        <p style={{ color: muted, fontSize: 14, marginBottom: 24 }}>
          {meta.label} — enter your account email and we will send a reset link.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            required
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            style={inputStyle(scope)}
          />
          {error ? <p style={{ color: '#f87171', fontSize: 14, marginTop: 12 }}>{error}</p> : null}
          <button
            type="submit"
            disabled={busy}
            style={{
              marginTop: 20,
              width: '100%',
              padding: 14,
              background: accent,
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              fontWeight: 700,
              cursor: busy ? 'wait' : 'pointer',
            }}
          >
            {busy ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
        <p style={{ marginTop: 24, fontSize: 14 }}>
          <Link to={meta.loginPath} style={{ color: muted, textDecoration: 'none' }}>
            ← Back to sign in
          </Link>
        </p>
      </div>
    </div>
  );
}

function inputStyle(scope) {
  return {
    width: '100%',
    boxSizing: 'border-box',
    padding: '12px 14px',
    borderRadius: 10,
    border: '1px solid rgba(255,255,255,0.12)',
    background: scope === 'marketplace' ? theme.bg1 : '#0f1419',
    color: scope === 'marketplace' ? theme.text : '#e8eaed',
    fontSize: 15,
  };
}
